import { Link } from 'react-router-dom';
import { Pencil, Languages } from 'lucide-react';
import { Delete } from '../../../features/DeleteEntity/index.js';
import './EntityCard.css';

export const EntityCard = ({
  children,
  image,
  title,
  subtitle,
  badge,
  fields = [],
  actions,
  editLink,
  localizationLink,
  onDelete,
  className = '',
}) => {
  return (
    <div className={`entity-card ${className}`}>
      <div className="entity-card__left">
        {image && (
          <div
            className="entity-card__image"
            style={{ backgroundImage: `url('${image}')` }}
          />
        )}
        <div className="entity-card__info">
          <div className="entity-card__title-row">
            <div className="entity-card__title">{title}</div>
            {badge && (
              <span className={`entity-card__badge entity-card__badge--${badge.variant || 'default'}`}>
                {badge.text}
              </span>
            )}
          </div>
          {subtitle && <div className="entity-card__subtitle">{subtitle}</div>}
        </div>
      </div>

      <div className="entity-card__right">
        {fields.map((field, index) => (
          <div key={index} className="entity-card__field">
            <div className="entity-card__field-name">{field.label}</div>
            <div className="entity-card__field-value">{field.value}</div>
          </div>
        ))}

        {children}

        <div className="entity-card__actions">
          {localizationLink && (
            <Link to={localizationLink} className="entity-card__action ui-icon-btn" title="Локализации">
              <Languages size={16} />
            </Link>
          )}
          {editLink && (
            <Link
              to={editLink}
              className="entity-card__action entity-card__action--edit ui-icon-btn"
              title="Редактировать"
            >
              <Pencil size={16} />
            </Link>
          )}
          {onDelete && (
            <Delete onConfirm={onDelete} size={16} />
          )}
          {actions}
        </div>
      </div>
    </div>
  );
};

export default EntityCard;
